module.exports = __webpack_public_path__ + "static/media/buenos-aires-al-aire-libre.fa0c1ea9.md";